/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeamIndexRouteImport } from './routes/team/index'
import { Route as SignupIndexRouteImport } from './routes/signup/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as RoutesIndexRouteImport } from './routes/routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as DestinationsIndexRouteImport } from './routes/destinations/index'
import { Route as ClientsIndexRouteImport } from './routes/clients/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AlertsIndexRouteImport } from './routes/alerts/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as LoginVerifyRouteImport } from './routes/login/verify'
import { Route as LoginOauthCallbackRouteImport } from './routes/login/oauth-callback'
import { Route as JobsJobIdRouteImport } from './routes/jobs/$jobId'
import { Route as ClientsClientIdRouteImport } from './routes/clients/$clientId'
import { Route as AppTeamIndexRouteImport } from './routes/app/team/index'
import { Route as AppSourcesIndexRouteImport } from './routes/app/sources/index'
import { Route as AppSetupIndexRouteImport } from './routes/app/setup/index'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as AppRoutesIndexRouteImport } from './routes/app/routes/index'
import { Route as AppJobsIndexRouteImport } from './routes/app/jobs/index'
import { Route as AppIntegrationsIndexRouteImport } from './routes/app/integrations/index'
import { Route as AppInboxIndexRouteImport } from './routes/app/inbox/index'
import { Route as AppDestinationsIndexRouteImport } from './routes/app/destinations/index'
import { Route as AppAuditIndexRouteImport } from './routes/app/audit/index'
import { Route as AppAlertsIndexRouteImport } from './routes/app/alerts/index'
import { Route as AppAgencyIndexRouteImport } from './routes/app/agency/index'
import { Route as AdminOauthDomainsIndexRouteImport } from './routes/admin/oauth-domains/index'
import { Route as AdminJobsIndexRouteImport } from './routes/admin/jobs/index'
import { Route as AdminInboxIndexRouteImport } from './routes/admin/inbox/index'
import { Route as AdminClientsIndexRouteImport } from './routes/admin/clients/index'
import { Route as AdminAuditIndexRouteImport } from './routes/admin/audit/index'
import { Route as AdminAlertsIndexRouteImport } from './routes/admin/alerts/index'
import { Route as AdminAgenciesIndexRouteImport } from './routes/admin/agencies/index'
import { Route as AppSourcesSourceIdRouteImport } from './routes/app/sources/$sourceId'
import { Route as AppSettingsBillingRouteImport } from './routes/app/settings/billing'
import { Route as AppSettingsApiKeysRouteImport } from './routes/app/settings/api-keys'
import { Route as AppRoutesRouteIdRouteImport } from './routes/app/routes/$routeId'
import { Route as AppInboxLeadIdRouteImport } from './routes/app/inbox/$leadId'
import { Route as AdminInboxLeadIdRouteImport } from './routes/admin/inbox/$leadId'
import { Route as AdminClientsClientIdRouteImport } from './routes/admin/clients/$clientId'
import { Route as AdminAgenciesAgencyIdRouteImport } from './routes/admin/agencies/$agencyId'
import { Route as AppAgencyUsersIndexRouteImport } from './routes/app/agency/users/index'
import { Route as AppAgencySettingsIndexRouteImport } from './routes/app/agency/settings/index'
import { Route as AppAgencyDomainsIndexRouteImport } from './routes/app/agency/domains/index'
import { Route as AppAgencyClientsIndexRouteImport } from './routes/app/agency/clients/index'
import { Route as AppSourcesSourceIdRoutesRouteIdMappingRouteImport } from './routes/app/sources/$sourceId/routes/$routeId/mapping'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamIndexRoute = TeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/signup/index.lazy').then((d) => d.Route))
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const RoutesIndexRoute = RoutesIndexRouteImport.update({
  id: '/routes/',
  path: '/routes/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login/index.lazy').then((d) => d.Route))
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const DestinationsIndexRoute = DestinationsIndexRouteImport.update({
  id: '/destinations/',
  path: '/destinations/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/app/index.lazy').then((d) => d.Route))
const AlertsIndexRoute = AlertsIndexRouteImport.update({
  id: '/alerts/',
  path: '/alerts/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin/index.lazy').then((d) => d.Route))
const LoginVerifyRoute = LoginVerifyRouteImport.update({
  id: '/login/verify',
  path: '/login/verify',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login/verify.lazy').then((d) => d.Route))
const LoginOauthCallbackRoute = LoginOauthCallbackRouteImport.update({
  id: '/login/oauth-callback',
  path: '/login/oauth-callback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/login/oauth-callback.lazy').then((d) => d.Route),
)
const JobsJobIdRoute = JobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsClientIdRoute = ClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTeamIndexRoute = AppTeamIndexRouteImport.update({
  id: '/app/team/',
  path: '/app/team/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/team/index.lazy').then((d) => d.Route),
)
const AppSourcesIndexRoute = AppSourcesIndexRouteImport.update({
  id: '/app/sources/',
  path: '/app/sources/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/sources/index.lazy').then((d) => d.Route),
)
const AppSetupIndexRoute = AppSetupIndexRouteImport.update({
  id: '/app/setup/',
  path: '/app/setup/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/setup/index.lazy').then((d) => d.Route),
)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/app/settings/',
  path: '/app/settings/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/settings/index.lazy').then((d) => d.Route),
)
const AppRoutesIndexRoute = AppRoutesIndexRouteImport.update({
  id: '/app/routes/',
  path: '/app/routes/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/routes/index.lazy').then((d) => d.Route),
)
const AppJobsIndexRoute = AppJobsIndexRouteImport.update({
  id: '/app/jobs/',
  path: '/app/jobs/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/jobs/index.lazy').then((d) => d.Route),
)
const AppIntegrationsIndexRoute = AppIntegrationsIndexRouteImport.update({
  id: '/app/integrations/',
  path: '/app/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppInboxIndexRoute = AppInboxIndexRouteImport.update({
  id: '/app/inbox/',
  path: '/app/inbox/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/inbox/index.lazy').then((d) => d.Route),
)
const AppDestinationsIndexRoute = AppDestinationsIndexRouteImport.update({
  id: '/app/destinations/',
  path: '/app/destinations/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/destinations/index.lazy').then((d) => d.Route),
)
const AppAuditIndexRoute = AppAuditIndexRouteImport.update({
  id: '/app/audit/',
  path: '/app/audit/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/audit/index.lazy').then((d) => d.Route),
)
const AppAlertsIndexRoute = AppAlertsIndexRouteImport.update({
  id: '/app/alerts/',
  path: '/app/alerts/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/alerts/index.lazy').then((d) => d.Route),
)
const AppAgencyIndexRoute = AppAgencyIndexRouteImport.update({
  id: '/app/agency/',
  path: '/app/agency/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/agency/index.lazy').then((d) => d.Route),
)
const AdminOauthDomainsIndexRoute = AdminOauthDomainsIndexRouteImport.update({
  id: '/admin/oauth-domains/',
  path: '/admin/oauth-domains/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/oauth-domains/index.lazy').then((d) => d.Route),
)
const AdminJobsIndexRoute = AdminJobsIndexRouteImport.update({
  id: '/admin/jobs/',
  path: '/admin/jobs/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/jobs/index.lazy').then((d) => d.Route),
)
const AdminInboxIndexRoute = AdminInboxIndexRouteImport.update({
  id: '/admin/inbox/',
  path: '/admin/inbox/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/inbox/index.lazy').then((d) => d.Route),
)
const AdminClientsIndexRoute = AdminClientsIndexRouteImport.update({
  id: '/admin/clients/',
  path: '/admin/clients/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/clients/index.lazy').then((d) => d.Route),
)
const AdminAuditIndexRoute = AdminAuditIndexRouteImport.update({
  id: '/admin/audit/',
  path: '/admin/audit/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/audit/index.lazy').then((d) => d.Route),
)
const AdminAlertsIndexRoute = AdminAlertsIndexRouteImport.update({
  id: '/admin/alerts/',
  path: '/admin/alerts/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/alerts/index.lazy').then((d) => d.Route),
)
const AdminAgenciesIndexRoute = AdminAgenciesIndexRouteImport.update({
  id: '/admin/agencies/',
  path: '/admin/agencies/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/agencies/index.lazy').then((d) => d.Route),
)
const AppSourcesSourceIdRoute = AppSourcesSourceIdRouteImport.update({
  id: '/app/sources/$sourceId',
  path: '/app/sources/$sourceId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/sources/$sourceId.lazy').then((d) => d.Route),
)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/app/settings/billing',
  path: '/app/settings/billing',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/settings/billing.lazy').then((d) => d.Route),
)
const AppSettingsApiKeysRoute = AppSettingsApiKeysRouteImport.update({
  id: '/app/settings/api-keys',
  path: '/app/settings/api-keys',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/settings/api-keys.lazy').then((d) => d.Route),
)
const AppRoutesRouteIdRoute = AppRoutesRouteIdRouteImport.update({
  id: '/app/routes/$routeId',
  path: '/app/routes/$routeId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/routes/$routeId.lazy').then((d) => d.Route),
)
const AppInboxLeadIdRoute = AppInboxLeadIdRouteImport.update({
  id: '/app/inbox/$leadId',
  path: '/app/inbox/$leadId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/inbox/$leadId.lazy').then((d) => d.Route),
)
const AdminInboxLeadIdRoute = AdminInboxLeadIdRouteImport.update({
  id: '/admin/inbox/$leadId',
  path: '/admin/inbox/$leadId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/inbox/$leadId.lazy').then((d) => d.Route),
)
const AdminClientsClientIdRoute = AdminClientsClientIdRouteImport.update({
  id: '/admin/clients/$clientId',
  path: '/admin/clients/$clientId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/clients/$clientId.lazy').then((d) => d.Route),
)
const AdminAgenciesAgencyIdRoute = AdminAgenciesAgencyIdRouteImport.update({
  id: '/admin/agencies/$agencyId',
  path: '/admin/agencies/$agencyId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/admin/agencies/$agencyId.lazy').then((d) => d.Route),
)
const AppAgencyUsersIndexRoute = AppAgencyUsersIndexRouteImport.update({
  id: '/app/agency/users/',
  path: '/app/agency/users/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/agency/users/index.lazy').then((d) => d.Route),
)
const AppAgencySettingsIndexRoute = AppAgencySettingsIndexRouteImport.update({
  id: '/app/agency/settings/',
  path: '/app/agency/settings/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/agency/settings/index.lazy').then((d) => d.Route),
)
const AppAgencyDomainsIndexRoute = AppAgencyDomainsIndexRouteImport.update({
  id: '/app/agency/domains/',
  path: '/app/agency/domains/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/agency/domains/index.lazy').then((d) => d.Route),
)
const AppAgencyClientsIndexRoute = AppAgencyClientsIndexRouteImport.update({
  id: '/app/agency/clients/',
  path: '/app/agency/clients/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/app/agency/clients/index.lazy').then((d) => d.Route),
)
const AppSourcesSourceIdRoutesRouteIdMappingRoute =
  AppSourcesSourceIdRoutesRouteIdMappingRouteImport.update({
    id: '/routes/$routeId/mapping',
    path: '/routes/$routeId/mapping',
    getParentRoute: () => AppSourcesSourceIdRoute,
  } as any).lazy(() =>
    import('./routes/app/sources/$sourceId/routes/$routeId/mapping.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/login/oauth-callback': typeof LoginOauthCallbackRoute
  '/login/verify': typeof LoginVerifyRoute
  '/admin/': typeof AdminIndexRoute
  '/alerts/': typeof AlertsIndexRoute
  '/app/': typeof AppIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/destinations/': typeof DestinationsIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/login/': typeof LoginIndexRoute
  '/routes/': typeof RoutesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/signup/': typeof SignupIndexRoute
  '/team/': typeof TeamIndexRoute
  '/admin/agencies/$agencyId': typeof AdminAgenciesAgencyIdRoute
  '/admin/clients/$clientId': typeof AdminClientsClientIdRoute
  '/admin/inbox/$leadId': typeof AdminInboxLeadIdRoute
  '/app/inbox/$leadId': typeof AppInboxLeadIdRoute
  '/app/routes/$routeId': typeof AppRoutesRouteIdRoute
  '/app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/app/settings/billing': typeof AppSettingsBillingRoute
  '/app/sources/$sourceId': typeof AppSourcesSourceIdRouteWithChildren
  '/admin/agencies/': typeof AdminAgenciesIndexRoute
  '/admin/alerts/': typeof AdminAlertsIndexRoute
  '/admin/audit/': typeof AdminAuditIndexRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/inbox/': typeof AdminInboxIndexRoute
  '/admin/jobs/': typeof AdminJobsIndexRoute
  '/admin/oauth-domains/': typeof AdminOauthDomainsIndexRoute
  '/app/agency/': typeof AppAgencyIndexRoute
  '/app/alerts/': typeof AppAlertsIndexRoute
  '/app/audit/': typeof AppAuditIndexRoute
  '/app/destinations/': typeof AppDestinationsIndexRoute
  '/app/inbox/': typeof AppInboxIndexRoute
  '/app/integrations/': typeof AppIntegrationsIndexRoute
  '/app/jobs/': typeof AppJobsIndexRoute
  '/app/routes/': typeof AppRoutesIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/setup/': typeof AppSetupIndexRoute
  '/app/sources/': typeof AppSourcesIndexRoute
  '/app/team/': typeof AppTeamIndexRoute
  '/app/agency/clients/': typeof AppAgencyClientsIndexRoute
  '/app/agency/domains/': typeof AppAgencyDomainsIndexRoute
  '/app/agency/settings/': typeof AppAgencySettingsIndexRoute
  '/app/agency/users/': typeof AppAgencyUsersIndexRoute
  '/app/sources/$sourceId/routes/$routeId/mapping': typeof AppSourcesSourceIdRoutesRouteIdMappingRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/login/oauth-callback': typeof LoginOauthCallbackRoute
  '/login/verify': typeof LoginVerifyRoute
  '/admin': typeof AdminIndexRoute
  '/alerts': typeof AlertsIndexRoute
  '/app': typeof AppIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/destinations': typeof DestinationsIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/jobs': typeof JobsIndexRoute
  '/login': typeof LoginIndexRoute
  '/routes': typeof RoutesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/signup': typeof SignupIndexRoute
  '/team': typeof TeamIndexRoute
  '/admin/agencies/$agencyId': typeof AdminAgenciesAgencyIdRoute
  '/admin/clients/$clientId': typeof AdminClientsClientIdRoute
  '/admin/inbox/$leadId': typeof AdminInboxLeadIdRoute
  '/app/inbox/$leadId': typeof AppInboxLeadIdRoute
  '/app/routes/$routeId': typeof AppRoutesRouteIdRoute
  '/app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/app/settings/billing': typeof AppSettingsBillingRoute
  '/app/sources/$sourceId': typeof AppSourcesSourceIdRouteWithChildren
  '/admin/agencies': typeof AdminAgenciesIndexRoute
  '/admin/alerts': typeof AdminAlertsIndexRoute
  '/admin/audit': typeof AdminAuditIndexRoute
  '/admin/clients': typeof AdminClientsIndexRoute
  '/admin/inbox': typeof AdminInboxIndexRoute
  '/admin/jobs': typeof AdminJobsIndexRoute
  '/admin/oauth-domains': typeof AdminOauthDomainsIndexRoute
  '/app/agency': typeof AppAgencyIndexRoute
  '/app/alerts': typeof AppAlertsIndexRoute
  '/app/audit': typeof AppAuditIndexRoute
  '/app/destinations': typeof AppDestinationsIndexRoute
  '/app/inbox': typeof AppInboxIndexRoute
  '/app/integrations': typeof AppIntegrationsIndexRoute
  '/app/jobs': typeof AppJobsIndexRoute
  '/app/routes': typeof AppRoutesIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/setup': typeof AppSetupIndexRoute
  '/app/sources': typeof AppSourcesIndexRoute
  '/app/team': typeof AppTeamIndexRoute
  '/app/agency/clients': typeof AppAgencyClientsIndexRoute
  '/app/agency/domains': typeof AppAgencyDomainsIndexRoute
  '/app/agency/settings': typeof AppAgencySettingsIndexRoute
  '/app/agency/users': typeof AppAgencyUsersIndexRoute
  '/app/sources/$sourceId/routes/$routeId/mapping': typeof AppSourcesSourceIdRoutesRouteIdMappingRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/login/oauth-callback': typeof LoginOauthCallbackRoute
  '/login/verify': typeof LoginVerifyRoute
  '/admin/': typeof AdminIndexRoute
  '/alerts/': typeof AlertsIndexRoute
  '/app/': typeof AppIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/destinations/': typeof DestinationsIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/login/': typeof LoginIndexRoute
  '/routes/': typeof RoutesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/signup/': typeof SignupIndexRoute
  '/team/': typeof TeamIndexRoute
  '/admin/agencies/$agencyId': typeof AdminAgenciesAgencyIdRoute
  '/admin/clients/$clientId': typeof AdminClientsClientIdRoute
  '/admin/inbox/$leadId': typeof AdminInboxLeadIdRoute
  '/app/inbox/$leadId': typeof AppInboxLeadIdRoute
  '/app/routes/$routeId': typeof AppRoutesRouteIdRoute
  '/app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/app/settings/billing': typeof AppSettingsBillingRoute
  '/app/sources/$sourceId': typeof AppSourcesSourceIdRouteWithChildren
  '/admin/agencies/': typeof AdminAgenciesIndexRoute
  '/admin/alerts/': typeof AdminAlertsIndexRoute
  '/admin/audit/': typeof AdminAuditIndexRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/inbox/': typeof AdminInboxIndexRoute
  '/admin/jobs/': typeof AdminJobsIndexRoute
  '/admin/oauth-domains/': typeof AdminOauthDomainsIndexRoute
  '/app/agency/': typeof AppAgencyIndexRoute
  '/app/alerts/': typeof AppAlertsIndexRoute
  '/app/audit/': typeof AppAuditIndexRoute
  '/app/destinations/': typeof AppDestinationsIndexRoute
  '/app/inbox/': typeof AppInboxIndexRoute
  '/app/integrations/': typeof AppIntegrationsIndexRoute
  '/app/jobs/': typeof AppJobsIndexRoute
  '/app/routes/': typeof AppRoutesIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/setup/': typeof AppSetupIndexRoute
  '/app/sources/': typeof AppSourcesIndexRoute
  '/app/team/': typeof AppTeamIndexRoute
  '/app/agency/clients/': typeof AppAgencyClientsIndexRoute
  '/app/agency/domains/': typeof AppAgencyDomainsIndexRoute
  '/app/agency/settings/': typeof AppAgencySettingsIndexRoute
  '/app/agency/users/': typeof AppAgencyUsersIndexRoute
  '/app/sources/$sourceId/routes/$routeId/mapping': typeof AppSourcesSourceIdRoutesRouteIdMappingRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clients/$clientId'
    | '/jobs/$jobId'
    | '/login/oauth-callback'
    | '/login/verify'
    | '/admin/'
    | '/alerts/'
    | '/app/'
    | '/clients/'
    | '/destinations/'
    | '/integrations/'
    | '/jobs/'
    | '/login/'
    | '/routes/'
    | '/settings/'
    | '/signup/'
    | '/team/'
    | '/admin/agencies/$agencyId'
    | '/admin/clients/$clientId'
    | '/admin/inbox/$leadId'
    | '/app/inbox/$leadId'
    | '/app/routes/$routeId'
    | '/app/settings/api-keys'
    | '/app/settings/billing'
    | '/app/sources/$sourceId'
    | '/admin/agencies/'
    | '/admin/alerts/'
    | '/admin/audit/'
    | '/admin/clients/'
    | '/admin/inbox/'
    | '/admin/jobs/'
    | '/admin/oauth-domains/'
    | '/app/agency/'
    | '/app/alerts/'
    | '/app/audit/'
    | '/app/destinations/'
    | '/app/inbox/'
    | '/app/integrations/'
    | '/app/jobs/'
    | '/app/routes/'
    | '/app/settings/'
    | '/app/setup/'
    | '/app/sources/'
    | '/app/team/'
    | '/app/agency/clients/'
    | '/app/agency/domains/'
    | '/app/agency/settings/'
    | '/app/agency/users/'
    | '/app/sources/$sourceId/routes/$routeId/mapping'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/clients/$clientId'
    | '/jobs/$jobId'
    | '/login/oauth-callback'
    | '/login/verify'
    | '/admin'
    | '/alerts'
    | '/app'
    | '/clients'
    | '/destinations'
    | '/integrations'
    | '/jobs'
    | '/login'
    | '/routes'
    | '/settings'
    | '/signup'
    | '/team'
    | '/admin/agencies/$agencyId'
    | '/admin/clients/$clientId'
    | '/admin/inbox/$leadId'
    | '/app/inbox/$leadId'
    | '/app/routes/$routeId'
    | '/app/settings/api-keys'
    | '/app/settings/billing'
    | '/app/sources/$sourceId'
    | '/admin/agencies'
    | '/admin/alerts'
    | '/admin/audit'
    | '/admin/clients'
    | '/admin/inbox'
    | '/admin/jobs'
    | '/admin/oauth-domains'
    | '/app/agency'
    | '/app/alerts'
    | '/app/audit'
    | '/app/destinations'
    | '/app/inbox'
    | '/app/integrations'
    | '/app/jobs'
    | '/app/routes'
    | '/app/settings'
    | '/app/setup'
    | '/app/sources'
    | '/app/team'
    | '/app/agency/clients'
    | '/app/agency/domains'
    | '/app/agency/settings'
    | '/app/agency/users'
    | '/app/sources/$sourceId/routes/$routeId/mapping'
  id:
    | '__root__'
    | '/'
    | '/clients/$clientId'
    | '/jobs/$jobId'
    | '/login/oauth-callback'
    | '/login/verify'
    | '/admin/'
    | '/alerts/'
    | '/app/'
    | '/clients/'
    | '/destinations/'
    | '/integrations/'
    | '/jobs/'
    | '/login/'
    | '/routes/'
    | '/settings/'
    | '/signup/'
    | '/team/'
    | '/admin/agencies/$agencyId'
    | '/admin/clients/$clientId'
    | '/admin/inbox/$leadId'
    | '/app/inbox/$leadId'
    | '/app/routes/$routeId'
    | '/app/settings/api-keys'
    | '/app/settings/billing'
    | '/app/sources/$sourceId'
    | '/admin/agencies/'
    | '/admin/alerts/'
    | '/admin/audit/'
    | '/admin/clients/'
    | '/admin/inbox/'
    | '/admin/jobs/'
    | '/admin/oauth-domains/'
    | '/app/agency/'
    | '/app/alerts/'
    | '/app/audit/'
    | '/app/destinations/'
    | '/app/inbox/'
    | '/app/integrations/'
    | '/app/jobs/'
    | '/app/routes/'
    | '/app/settings/'
    | '/app/setup/'
    | '/app/sources/'
    | '/app/team/'
    | '/app/agency/clients/'
    | '/app/agency/domains/'
    | '/app/agency/settings/'
    | '/app/agency/users/'
    | '/app/sources/$sourceId/routes/$routeId/mapping'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClientsClientIdRoute: typeof ClientsClientIdRoute
  JobsJobIdRoute: typeof JobsJobIdRoute
  LoginOauthCallbackRoute: typeof LoginOauthCallbackRoute
  LoginVerifyRoute: typeof LoginVerifyRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AlertsIndexRoute: typeof AlertsIndexRoute
  AppIndexRoute: typeof AppIndexRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  DestinationsIndexRoute: typeof DestinationsIndexRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
  JobsIndexRoute: typeof JobsIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  RoutesIndexRoute: typeof RoutesIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SignupIndexRoute: typeof SignupIndexRoute
  TeamIndexRoute: typeof TeamIndexRoute
  AdminAgenciesAgencyIdRoute: typeof AdminAgenciesAgencyIdRoute
  AdminClientsClientIdRoute: typeof AdminClientsClientIdRoute
  AdminInboxLeadIdRoute: typeof AdminInboxLeadIdRoute
  AppInboxLeadIdRoute: typeof AppInboxLeadIdRoute
  AppRoutesRouteIdRoute: typeof AppRoutesRouteIdRoute
  AppSettingsApiKeysRoute: typeof AppSettingsApiKeysRoute
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSourcesSourceIdRoute: typeof AppSourcesSourceIdRouteWithChildren
  AdminAgenciesIndexRoute: typeof AdminAgenciesIndexRoute
  AdminAlertsIndexRoute: typeof AdminAlertsIndexRoute
  AdminAuditIndexRoute: typeof AdminAuditIndexRoute
  AdminClientsIndexRoute: typeof AdminClientsIndexRoute
  AdminInboxIndexRoute: typeof AdminInboxIndexRoute
  AdminJobsIndexRoute: typeof AdminJobsIndexRoute
  AdminOauthDomainsIndexRoute: typeof AdminOauthDomainsIndexRoute
  AppAgencyIndexRoute: typeof AppAgencyIndexRoute
  AppAlertsIndexRoute: typeof AppAlertsIndexRoute
  AppAuditIndexRoute: typeof AppAuditIndexRoute
  AppDestinationsIndexRoute: typeof AppDestinationsIndexRoute
  AppInboxIndexRoute: typeof AppInboxIndexRoute
  AppIntegrationsIndexRoute: typeof AppIntegrationsIndexRoute
  AppJobsIndexRoute: typeof AppJobsIndexRoute
  AppRoutesIndexRoute: typeof AppRoutesIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSetupIndexRoute: typeof AppSetupIndexRoute
  AppSourcesIndexRoute: typeof AppSourcesIndexRoute
  AppTeamIndexRoute: typeof AppTeamIndexRoute
  AppAgencyClientsIndexRoute: typeof AppAgencyClientsIndexRoute
  AppAgencyDomainsIndexRoute: typeof AppAgencyDomainsIndexRoute
  AppAgencySettingsIndexRoute: typeof AppAgencySettingsIndexRoute
  AppAgencyUsersIndexRoute: typeof AppAgencyUsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/': {
      id: '/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof TeamIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/': {
      id: '/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof SignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/routes/': {
      id: '/routes/'
      path: '/routes'
      fullPath: '/routes/'
      preLoaderRoute: typeof RoutesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/destinations/': {
      id: '/destinations/'
      path: '/destinations'
      fullPath: '/destinations/'
      preLoaderRoute: typeof DestinationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/app'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts/': {
      id: '/alerts/'
      path: '/alerts'
      fullPath: '/alerts/'
      preLoaderRoute: typeof AlertsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/verify': {
      id: '/login/verify'
      path: '/login/verify'
      fullPath: '/login/verify'
      preLoaderRoute: typeof LoginVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/oauth-callback': {
      id: '/login/oauth-callback'
      path: '/login/oauth-callback'
      fullPath: '/login/oauth-callback'
      preLoaderRoute: typeof LoginOauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/$jobId': {
      id: '/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof JobsJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$clientId': {
      id: '/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/team/': {
      id: '/app/team/'
      path: '/app/team'
      fullPath: '/app/team/'
      preLoaderRoute: typeof AppTeamIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/sources/': {
      id: '/app/sources/'
      path: '/app/sources'
      fullPath: '/app/sources/'
      preLoaderRoute: typeof AppSourcesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/setup/': {
      id: '/app/setup/'
      path: '/app/setup'
      fullPath: '/app/setup/'
      preLoaderRoute: typeof AppSetupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/app/settings'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/routes/': {
      id: '/app/routes/'
      path: '/app/routes'
      fullPath: '/app/routes/'
      preLoaderRoute: typeof AppRoutesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/jobs/': {
      id: '/app/jobs/'
      path: '/app/jobs'
      fullPath: '/app/jobs/'
      preLoaderRoute: typeof AppJobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/integrations/': {
      id: '/app/integrations/'
      path: '/app/integrations'
      fullPath: '/app/integrations/'
      preLoaderRoute: typeof AppIntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/inbox/': {
      id: '/app/inbox/'
      path: '/app/inbox'
      fullPath: '/app/inbox/'
      preLoaderRoute: typeof AppInboxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/destinations/': {
      id: '/app/destinations/'
      path: '/app/destinations'
      fullPath: '/app/destinations/'
      preLoaderRoute: typeof AppDestinationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/audit/': {
      id: '/app/audit/'
      path: '/app/audit'
      fullPath: '/app/audit/'
      preLoaderRoute: typeof AppAuditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/alerts/': {
      id: '/app/alerts/'
      path: '/app/alerts'
      fullPath: '/app/alerts/'
      preLoaderRoute: typeof AppAlertsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/agency/': {
      id: '/app/agency/'
      path: '/app/agency'
      fullPath: '/app/agency/'
      preLoaderRoute: typeof AppAgencyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/oauth-domains/': {
      id: '/admin/oauth-domains/'
      path: '/admin/oauth-domains'
      fullPath: '/admin/oauth-domains/'
      preLoaderRoute: typeof AdminOauthDomainsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/jobs/': {
      id: '/admin/jobs/'
      path: '/admin/jobs'
      fullPath: '/admin/jobs/'
      preLoaderRoute: typeof AdminJobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/inbox/': {
      id: '/admin/inbox/'
      path: '/admin/inbox'
      fullPath: '/admin/inbox/'
      preLoaderRoute: typeof AdminInboxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/clients/': {
      id: '/admin/clients/'
      path: '/admin/clients'
      fullPath: '/admin/clients/'
      preLoaderRoute: typeof AdminClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit/': {
      id: '/admin/audit/'
      path: '/admin/audit'
      fullPath: '/admin/audit/'
      preLoaderRoute: typeof AdminAuditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/alerts/': {
      id: '/admin/alerts/'
      path: '/admin/alerts'
      fullPath: '/admin/alerts/'
      preLoaderRoute: typeof AdminAlertsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/agencies/': {
      id: '/admin/agencies/'
      path: '/admin/agencies'
      fullPath: '/admin/agencies/'
      preLoaderRoute: typeof AdminAgenciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/sources/$sourceId': {
      id: '/app/sources/$sourceId'
      path: '/app/sources/$sourceId'
      fullPath: '/app/sources/$sourceId'
      preLoaderRoute: typeof AppSourcesSourceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/settings/billing': {
      id: '/app/settings/billing'
      path: '/app/settings/billing'
      fullPath: '/app/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/settings/api-keys': {
      id: '/app/settings/api-keys'
      path: '/app/settings/api-keys'
      fullPath: '/app/settings/api-keys'
      preLoaderRoute: typeof AppSettingsApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/routes/$routeId': {
      id: '/app/routes/$routeId'
      path: '/app/routes/$routeId'
      fullPath: '/app/routes/$routeId'
      preLoaderRoute: typeof AppRoutesRouteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/inbox/$leadId': {
      id: '/app/inbox/$leadId'
      path: '/app/inbox/$leadId'
      fullPath: '/app/inbox/$leadId'
      preLoaderRoute: typeof AppInboxLeadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/inbox/$leadId': {
      id: '/admin/inbox/$leadId'
      path: '/admin/inbox/$leadId'
      fullPath: '/admin/inbox/$leadId'
      preLoaderRoute: typeof AdminInboxLeadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/clients/$clientId': {
      id: '/admin/clients/$clientId'
      path: '/admin/clients/$clientId'
      fullPath: '/admin/clients/$clientId'
      preLoaderRoute: typeof AdminClientsClientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/agencies/$agencyId': {
      id: '/admin/agencies/$agencyId'
      path: '/admin/agencies/$agencyId'
      fullPath: '/admin/agencies/$agencyId'
      preLoaderRoute: typeof AdminAgenciesAgencyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/agency/users/': {
      id: '/app/agency/users/'
      path: '/app/agency/users'
      fullPath: '/app/agency/users/'
      preLoaderRoute: typeof AppAgencyUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/agency/settings/': {
      id: '/app/agency/settings/'
      path: '/app/agency/settings'
      fullPath: '/app/agency/settings/'
      preLoaderRoute: typeof AppAgencySettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/agency/domains/': {
      id: '/app/agency/domains/'
      path: '/app/agency/domains'
      fullPath: '/app/agency/domains/'
      preLoaderRoute: typeof AppAgencyDomainsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/agency/clients/': {
      id: '/app/agency/clients/'
      path: '/app/agency/clients'
      fullPath: '/app/agency/clients/'
      preLoaderRoute: typeof AppAgencyClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/sources/$sourceId/routes/$routeId/mapping': {
      id: '/app/sources/$sourceId/routes/$routeId/mapping'
      path: '/routes/$routeId/mapping'
      fullPath: '/app/sources/$sourceId/routes/$routeId/mapping'
      preLoaderRoute: typeof AppSourcesSourceIdRoutesRouteIdMappingRouteImport
      parentRoute: typeof AppSourcesSourceIdRoute
    }
  }
}

interface AppSourcesSourceIdRouteChildren {
  AppSourcesSourceIdRoutesRouteIdMappingRoute: typeof AppSourcesSourceIdRoutesRouteIdMappingRoute
}

const AppSourcesSourceIdRouteChildren: AppSourcesSourceIdRouteChildren = {
  AppSourcesSourceIdRoutesRouteIdMappingRoute:
    AppSourcesSourceIdRoutesRouteIdMappingRoute,
}

const AppSourcesSourceIdRouteWithChildren =
  AppSourcesSourceIdRoute._addFileChildren(AppSourcesSourceIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClientsClientIdRoute: ClientsClientIdRoute,
  JobsJobIdRoute: JobsJobIdRoute,
  LoginOauthCallbackRoute: LoginOauthCallbackRoute,
  LoginVerifyRoute: LoginVerifyRoute,
  AdminIndexRoute: AdminIndexRoute,
  AlertsIndexRoute: AlertsIndexRoute,
  AppIndexRoute: AppIndexRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  DestinationsIndexRoute: DestinationsIndexRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  JobsIndexRoute: JobsIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  RoutesIndexRoute: RoutesIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SignupIndexRoute: SignupIndexRoute,
  TeamIndexRoute: TeamIndexRoute,
  AdminAgenciesAgencyIdRoute: AdminAgenciesAgencyIdRoute,
  AdminClientsClientIdRoute: AdminClientsClientIdRoute,
  AdminInboxLeadIdRoute: AdminInboxLeadIdRoute,
  AppInboxLeadIdRoute: AppInboxLeadIdRoute,
  AppRoutesRouteIdRoute: AppRoutesRouteIdRoute,
  AppSettingsApiKeysRoute: AppSettingsApiKeysRoute,
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSourcesSourceIdRoute: AppSourcesSourceIdRouteWithChildren,
  AdminAgenciesIndexRoute: AdminAgenciesIndexRoute,
  AdminAlertsIndexRoute: AdminAlertsIndexRoute,
  AdminAuditIndexRoute: AdminAuditIndexRoute,
  AdminClientsIndexRoute: AdminClientsIndexRoute,
  AdminInboxIndexRoute: AdminInboxIndexRoute,
  AdminJobsIndexRoute: AdminJobsIndexRoute,
  AdminOauthDomainsIndexRoute: AdminOauthDomainsIndexRoute,
  AppAgencyIndexRoute: AppAgencyIndexRoute,
  AppAlertsIndexRoute: AppAlertsIndexRoute,
  AppAuditIndexRoute: AppAuditIndexRoute,
  AppDestinationsIndexRoute: AppDestinationsIndexRoute,
  AppInboxIndexRoute: AppInboxIndexRoute,
  AppIntegrationsIndexRoute: AppIntegrationsIndexRoute,
  AppJobsIndexRoute: AppJobsIndexRoute,
  AppRoutesIndexRoute: AppRoutesIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSetupIndexRoute: AppSetupIndexRoute,
  AppSourcesIndexRoute: AppSourcesIndexRoute,
  AppTeamIndexRoute: AppTeamIndexRoute,
  AppAgencyClientsIndexRoute: AppAgencyClientsIndexRoute,
  AppAgencyDomainsIndexRoute: AppAgencyDomainsIndexRoute,
  AppAgencySettingsIndexRoute: AppAgencySettingsIndexRoute,
  AppAgencyUsersIndexRoute: AppAgencyUsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
